import * as gqlb from "gql-query-builder";

export const LIST_SHIPMENT_TRANSACTION_TYPES = gqlb.query({
    operation: "listShipmentTransactionTypes",
    fields: [
      {
        operation: "paginatorInfo",
        fields: [
          "count",
          "currentPage",
          "firstItem",
          "hasMorePages",
          "lastItem",
          "lastPage",
          "perPage",
          "total",
        ],
        variables: {},
      },
      {
        operation: "data",
        fields: [
            "id",
            "code",
            "name",
            "active",
            {
                type: ["code", "name"],
            },
            {
                sequence: ["id", "name"],
            },
            {
                branch: ["id", "name"],
            },
            {
                glAccount: ["id", "name"],
            },
            {
                journalType: ["id", "name"],
            },
            {
                subsidiary: ["id", "name"],
            }
        ],
        variables: {},
      },
    ],
    variables: {
        input: {
            type: "ListShipmentTransactionTypesFilterInput"
        },
        page: {
            type: "Int",
          },
          first: {
            type: "Int",
          },
    },
})

export const SAVE_SHIPMENT_TRANSACTION_TYPE= gqlb.mutation({
  operation: "saveShipmentTransactionType",
  fields: ["id", "code", "active"],
  variables: {
    input: {
      type: " ShipmentTransactionTypeInput",
      required: true,
    },
  },
});

export const SHIPMENT_TRANSACTION_TYP_ID = gqlb.query({
  operation: "shipmentTransactionType",
  fields: [
      "id",
      "code",
      "name",
      "active",
      {
          type: ["code", "name"],
      },
      {
          sequence: ["id", "name"],
      },
      {
          branch: ["id", "name"],
      },
      {
          glAccount: ["id", "name"],
      },
      {
          journalType: ["id", "name"],
      },
      {
          subsidiary: ["id", "name"],
      }
  ],
  variables: {
    id: {
      type: "Int",
      required: true,
    },
  },
});




